/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { of } from "rxjs";
import { MyInjector } from "@src/app/app.module";
import { Txn } from "@src/app/model/txn";
import { ActionColor, IFormAction } from "@src/app/shared/form/form.component";
import { InvoiceService } from "@src/app/modules/txn/invoice.service";
import { concatMap } from "rxjs/operators";
import { ConfirmDialogService } from "@src/app/shared/dialogs/confirmDialog";
import { PersonService } from "@src/app/pages/person-page/person.service";

export class RegeneratePDFAction implements IFormAction {
    name = $localize`Regenerate PDF`;
    color: ActionColor = 'primary';
    show = false;
    icon = 'autorenew';
    approvalNeeded = false;
    disabled = false;
    approvalText: string;
    tipText: string;
    txn: Txn;

    invoiceSvc = MyInjector.instance.get(InvoiceService)
    personSvc = MyInjector.instance.get(PersonService);
    cds = MyInjector.instance.get(ConfirmDialogService);

    action() {
        const title = $localize `Regenerate PDF file for charges?`
        if (this.txn.unit.ownerId) {
            return this.personSvc.getOne(this.txn.unit.ownerId, null).pipe(concatMap(o => {

                const contactName = o.id == this.txn.personId ? "the same though there details may be changed." 
                    : $localize `a completely different contact (${o.fullName}). The person on this charge will be changed if you proceed.`;
                const msg = $localize `
                    Do you wish to regenerate the PDF for this charge now? 
                    Note unit owner name is ${contactName}
                `
                const choice = {
                    title,
                    msg,
                    options: [{ name: 'OK', returns: true }]
                }            
                return this.cds.openChoice(choice).pipe(concatMap((doit) => {
                    console.log(doit);
                    if (doit) {
                        return this.invoiceSvc.regeneratePDF(this.txn);                   
                    }
                    return of(null)
                } ));
            }))
        } else {
            const msg = $localize `There is no owner on this unit - are you sure you want to go ahead and generate the PDF? `;
            const choice = {
                title,
                msg,
                options: [{ name: 'OK', returns: true }]
            }            
            return this.cds.openChoice(choice).pipe(concatMap((doit) => {
                console.log(doit);
                if (doit) {
                    return this.invoiceSvc.regeneratePDF(this.txn);                   
                }
                return of(null)
            } ));
            
        }
    }
    //  setup(serviceRequest: ServiceRequest) {
    setup(txn: Txn) {
        this.show = true;
        this.txn = txn;
    }
}
